/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IStackItemStyles, IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';

export const getStackStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: {
            backgroundColor: theme.palette.neutralLighterAlt,
            height: '100vh',
            margin: 0,
            overflowY: 'auto',
        },
    };
};

export const getInnerStackStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            height: '100%',
        },
    };
};

export const getSidebarStyles = (theme: ITheme): Partial<IStackItemStyles> => {
    return {
        root: {
            flexBasis: '320px',
            borderRightWidth: '1px',
            borderRightStyle: 'solid',
            borderRightColor: theme.palette.neutralTertiaryAlt,
            paddingTop: '1.875rem',
        },
    };
};

export const getContentStackItemStyles = (): Partial<IStackItemStyles> => {
    // Using this height for adapting safari
    return { root: { height: 'calc(100vh - 7.2rem)' } };
};
